module.exports = __webpack_public_path__ + "static/img/job_3.ac2042e1.png";